var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "lm03yx7oua",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408 -674) translate(408 674)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "oqx6oco9ob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lm03yx7oua"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#oqx6oco9ob)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.901 6.255c.455-.313 1-.423 1.534-.313.534.11.995.43 1.297.897l5.265 8.193c.207.322.226.738.05 1.079-.179.342-.525.556-.9.556H1.852c-.375 0-.722-.214-.898-.556-.178-.343-.158-.758.05-1.08l3.464-5.36.02-.03.06-.086.02-.028c.714-.914 2-1.06 2.875-.331l.83.685 2.09-3.081c.145-.215.328-.399.538-.545zm-5.85-2.922c.846 0 1.531.707 1.531 1.58 0 .871-.685 1.578-1.53 1.578s-1.53-.707-1.53-1.579.685-1.579 1.53-1.579z",
    transform: "translate(10 10)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaces);
export default __webpack_public_path__ + "static/media/places.4f569954.svg";
export { ForwardRef as ReactComponent };